module.exports = __webpack_public_path__ + "static/tuv-dfbf2a086dcc9ac08579ee5d926a7c61.webp";